<div class="panel-block">
    <p class="control">
        <ng-select [items]="filter.options" [multiple]="true" [(ngModel)]="selected" (change)="updateFilterChange()">
        </ng-select>
    </p>
</div>
